<template>
  <p>
    <img src="https://www.uma.pt/wp-content/themes/uma/images/error_icon-29.png" 
      class="icon_erro"> 
    {{ $t("semdocumentos") }}
  </p>
</template>

<script>
export default {
  setup() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.icon_erro {
  width: 38px;
  margin-right: 10px;
  margin-bottom: 5px;
}

p {
  font-size: 16px;
  font-family: "Montserrat Semibold";
  color: #707475;
  padding-top: 20px;
  padding-bottom: 1rem;
  border-bottom: 1px solid #a7a5a5;
}

@media (max-width: 767px){
  .icon_erro {
    width: 28px;
  }
  p{
    padding-top: 0px;
    margin-bottom: 0px;
    font-size: 14px;
    border-bottom: transparent;
  }
}
</style>